// ESM-Huelle fuer lib/scripts/components/CMP_CPre.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CPre(id)
{
    this.construct(id);

    this.name = "CPre";
	this.htmlType = "pre";

	this.properties = 
	{
		value: "",
        attributes: {},
		styles:	{}
	}
}

CPre.prototype = new CComponent;

CPre.prototype.clear = function()
{
	this.properties.value = "";
	this.reValue();
}

export { CPre };
